/* eslint-disable no-restricted-syntax */
import { Helpers as CoreHelpers, Config, InitializeTypes, IFinalResponse } from '@smiles/core-engine';
import { Helpers as AccountHelpers, Services as AccountServices } from '@smiles/core-account';
import { Services as UtilsServices } from '@smiles/core-utils';

const WINDOW = window as any;
let smlsEnv = WINDOW.smlsEnv as string;

if (smlsEnv.includes('uat')) smlsEnv = smlsEnv.replace(/uat/, 'hml');
const ENV_CORE = smlsEnv.toLocaleUpperCase() + (WINDOW.isDotEnv ? '-N' : '');

const configLib: InitializeTypes = {
  service: {
    environment: ENV_CORE as any,
    logger: sessionStorage.getItem('smls-debug') === 'true',
    timeout: 60000,
    region: 'Brasil',
  },
  channel: 'WEB',
  receiveConstants: true,
  loggerXstate: false,
};
export const constants = {} as any;
export const smilesEnv = smlsEnv;

export async function init() {
  const initResponse = await Config.initialize(configLib);
  constants.recaptcha = CoreHelpers.getConstants('recaptcha');
  constants.googleMaps = CoreHelpers.getConstants('apiGoogleMaps');

  sessionStorage.setItem('@core:smiles:initialize', JSON.stringify(initResponse));
}

export { CoreHelpers, AccountHelpers, AccountServices, UtilsServices, Config };

export type { IFinalResponse };
